import React from 'react'

function SizeGuideContent({sizeGuideData, isFullSize, viewFullSizeCb}) {

    if(isFullSize) return null;

    const onViewFullSizeClick = () => {
        viewFullSizeCb(true);
    }
    return (
        <div className="product-info">
            <div className="row">
              <div className="col-md-12">
                <div className="heading bg-light">
                  <h4 className="text-black text-center">
                    {sizeGuideData?.subtitle_text || ""}
                  </h4>
                </div>
              </div>
              <div className="col-md-4 col-6">
                <img
                  src={sizeGuideData?.product_details?.image_src || ""}
                  className="img-fluid mx-auto d-block"
                  alt=""
                />
              </div>
              <div className="col-md-7 col-6">
                <div className="text mt-50">
                  <h5 className="text-black text-left">
                    {sizeGuideData?.product_details?.designer_name || ""}
                  </h5>
                  <p className="text-left">
                    {sizeGuideData?.product_details?.name || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive mt-25">
                  <table className="table text-center">
                    <thead>
                      <tr>
                        {sizeGuideData?.row_header_text?.map(
                          (header, index) => {
                            return <th key={index}>{header}</th>;
                          }
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {sizeGuideData?.row_data?.map((row, index) => {
                        return (
                          <tr key={index}>
                            {row?.map((data, dIndx) => {
                              return <td key={dIndx}>{data}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-6 mx-auto" style={{padding: "0px"}}>
                <button className="btn-primary mt-20" onClick={onViewFullSizeClick}>
                  VIEW FULL SIZE GUIDE
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="bt-blck"></div>
              </div>
              <div className="col-md-8 mx-auto">
                <div className="disclaimer-text">
                  <p className="text-black">
                    {sizeGuideData?.help_subtitle_text || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
    )
}

export default SizeGuideContent
